// ligfrontend/src/components/common/DatePicker.jsx
import React, { useState } from "react";
import "./DatePicker.css";

const DatePicker = ({ value, onChange }) => {
  const [isEditing, setIsEditing] = useState(false);

  const formatDisplayDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      weekday: "short",
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  };

  const formatInputDate = (dateString) => {
    const date = new Date(dateString);
    // Use local timezone methods instead of ISO
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const handleDateChange = (e) => {
    // Parse the date string as local date, not UTC
    const [year, month, day] = e.target.value.split("-");
    const newDate = new Date(year, month - 1, day);
    onChange(newDate);
    setIsEditing(false);
  };

  if (isEditing) {
    return (
      <div className="date-picker editing">
        <input
          type="date"
          defaultValue={formatInputDate(value)}
          onChange={handleDateChange}
          onBlur={() => setIsEditing(false)}
          autoFocus
          className="date-picker-input"
        />
      </div>
    );
  }

  return (
    <div className="date-picker" onClick={() => setIsEditing(true)}>
      <span className="date-icon">📅</span>
      <span className="date-text">{formatDisplayDate(value)}</span>
    </div>
  );
};

export default DatePicker;
